import { render } from "./TipoPlanes.vue?vue&type=template&id=2d4aaf5c"
import script from "./TipoPlanes.vue?vue&type=script&lang=js"
export * from "./TipoPlanes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__